export function CmsDoctors() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-text">Doctor Directory CMS</h1>
      <p className="text-text-muted">Manage doctor profiles and directory listings here.</p>
    </div>
  )
}
